import { FGSelectInput, IFGSelectInputProps } from "nsitools-react";
import * as React from "react";
import { useReferential } from "../../../hooks/useReferential";

export interface IFGClubSelectProps extends IFGSelectInputProps<any> {
  name: string;
  label: string;
}

export const FGClubSelect: React.FunctionComponent<IFGClubSelectProps> = (props) => {
  const [clubs, cloading] = useReferential((a) => a.getClubs(null), true, []);

  return <FGSelectInput name={props.name} label={props.label} items={clubs} loading={cloading} {...props} />;
};
